module.exports = __webpack_public_path__ + "img/trash.576d4be6.svg";